<template>
    <div>
        <div class="page-content">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-12">
                        <div class="card border">
                            <div class="card-body">
                                <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                                    <h4 class="mb-sm-0">{{this.label}} Data Sub Kategori</h4>
                                    <div class="page-title-right">
                                        <ol class="breadcrumb m-0">
                                            <li class="breadcrumb-item"><router-link :to="{name : 'skd_sub_category'}">Data Sub Kategori</router-link></li>
                                            <li class="breadcrumb-item active">Form</li>
                                        </ol>
                                    </div>
                                </div>

                                <form v-on:submit.prevent="onSubmit">
                                    <div class="row">
                                        <input type="hidden" name="id" v-model="form.id">
                                        <div class="form-group col-md-6 mt-3">
                                            <label>Kategori</label>
                                            <select class="form-select" v-model="form.category_id" :class="{ 'is-invalid': submitted && $v.form.category_id.$error }">
                                                <option value="">Pilih Kategori</option>
                                                <option v-for="(item, index) in dataCategory" :key="index" :value="item.id">{{item.name}}</option>
                                            </select>
                                            <div v-if="submitted && !$v.form.category_id.required" class="invalid-feedback">Kategori Wajib diisi!</div>
                                        </div>
                                        <div class="form-group col-md-6 mt-3">
                                            <label>Kode</label>
                                            <input type="text" class="form-control"
                                                placeholder="Masukan data..." v-model="form.code" :class="{ 'is-invalid': submitted && $v.form.code.$error }">
                                            <div v-if="submitted && !$v.form.code.required" class="invalid-feedback">Kode Wajib diisi!</div>    
                                        </div>
                                        <div class="form-group col-md-12 mt-3">
                                            <label>Nama</label>
                                            <input type="text" class="form-control"
                                                placeholder="Masukan data..." v-model="form.name" :class="{ 'is-invalid': submitted && $v.form.name.$error }">
                                            <div v-if="submitted && !$v.form.name.required" class="invalid-feedback">Nama Wajib diisi!</div>    
                                        </div>
                                        <div class="form-group col-md-12 mt-3">
                                            <label>Deskripsi</label>
                                            <textarea
                                                rows="4"
                                                class="form-control"
                                                placeholder="Masukan data..." v-model="form.description" :class="{ 'is-invalid': submitted && $v.form.description.$error }">
                                            </textarea>
                                            <div v-if="submitted && !$v.form.description.required" class="invalid-feedback">Deskripsi Wajib diisi!</div>    
                                        </div>
                                    </div>
                                    <div class="button-items mt-3">
                                        <button type="submit" class="btn btn-primary" :disabled="waiting">
                                        <i class="fa fa-save"></i> {{ waiting ? 'Harap tunggu ...' : 'Simpan' }}</button>
                                        <router-link :to="{name : 'skd_sub_category'}" class="btn btn-outline-primary">Kembali</router-link>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {
        required
    } from "vuelidate/lib/validators";
    
    export default {
        name: 'skd_sub_category',
        metaInfo: {
            title: 'Form Sub Kategori',
            titleTemplate: '%s - Gubuk Sains Prima'
        },
        created() {
            this.getCategory();
            this.getDataByID(this.$route.params.id);
        },
        data() {
            return {
                label           : 'Tambah',
                form : {
                    id          : "",
                    code        : "",
                    name        : "",
                    description : "",
                    category_id : "",
                },
                submitted       : false,
                waiting         : false,
                dataCategory    : []
            }
        },
        validations: {
            form: {
                category_id: {
                    required
                },
                code: {
                    required
                },
                name: {
                    required
                },
                description: {
                    required
                },
            }
        },
        methods: {
            getCategory: function() {
                let uri         = process.env.VUE_APP_APIHOST+'general/list/category';

                this.$http.get(uri).then(res => {
                    this.dataCategory = res.data.data;
                });
            },
            onSubmit: function () {
                this.waiting    = true;
                this.submitted  = true;

                // stop here if form is invalid
                this.$v.$touch();
                if (this.$v.$invalid) {
                    this.$swal({
                        icon: 'warning',
                        title: 'Ups!',
                        text: 'Harap lengkapi form',
                    });

                    this.waiting = false;
                    return;
                } else {    
                    let formData = new FormData();

                    formData.append('id', this.form.id);
                    formData.append('code', this.form.code);
                    formData.append('name', this.form.name);
                    formData.append('description', this.form.description);
                    formData.append('category_id', this.form.category_id);

                    this.$http.post(process.env.VUE_APP_APIHOST + 'admin/sub-category/save', formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    })
                    .then(response => {
                            if (response.data.status) {
                                this.$swal({
                                    icon: 'success',
                                    title: 'Success',
                                    text: response.data.message,
                                    confirmButtonText: 'OK'
                                }).then((result) => {
                                    if (result.value) {
                                        this.$router.push({ name: 'skd_sub_category' });
                                    }
                                });
                            } else {
                                this.$swal({
                                    icon: 'warning',
                                    title: 'Ups!',
                                    text: response.data.message,
                                });
                            }
                            this.waiting = false;
                        })
                    .catch(function () {
                        this.$swal({
                            icon: 'warning',
                            title: 'Ups!',
                            text: 'Please check your internet connection.',
                        });
                        this.waiting = false;
                        return;
                    });

                }
            },
            getDataByID: function(id) {
                if (typeof (id) !== 'undefined' && id !== null) {
                    this.label  = "Ubah";

                    let uri     = process.env.VUE_APP_APIHOST+'admin/sub-category/detail';

                    this.dataFetch  = true;                
                    this.$http.get(uri,{
                        params : {
                            id : id
                        }
                    }).then(res => {
                        if(res.data.status) {
                            let getResponse = res.data.data;

                            this.form.id            = getResponse.id;
                            this.form.code          = getResponse.code;
                            this.form.name          = getResponse.name;
                            this.form.description   = getResponse.description;
                            this.form.category_id   = getResponse.category_id;
                        } else {
                            this.$swal({
                                icon: 'warning',
                                title: 'Ups!',
                                text: res.data.message,
                                confirmButtonText: 'OK'
                            }).then((result) => {
                                if (result.value) {
                                    this.$router.push({ name: 'skd_sub_category' });
                                }
                            });
                        }
                    });
                }
            }
        }
    }
</script>